<template>
  <div class="nx-bag-create-tag-button">
    <nx-bag-block-button :title="$t('message.bag.persistSearch')" @click="dialog = true"/>
    <nx-dialog v-model="dialog" max-width="400px" :title="$t('message.bag.persistSearch')">
      <v-text-field :label="$t('message.bag.searchName')" v-model="searchName" @keyup.enter="createSearch" />
      <template slot="actions">
        <v-btn color="secondary"
               flat
               @click="close"
               :disabled="loading"
               :loading="loading"
          >{{ $t('message.common.close') }}</v-btn>
        <v-btn color="secondary"
               flat
               @click="createSearch"
               :disabled="disabled"
               :loading="loading"
        >{{ $t('message.common.save') }}</v-btn>
      </template>
    </nx-dialog>
  </div>
</template>

<script>
import NxBagBlockButton from '../common/BagBlockButton';
import NxDialog from '@/components/dialogs/Dialog';

export default {
  components: {
    NxDialog,
    NxBagBlockButton,
  },
  props: {
    search: Object,
  },
  data() {
    return {
      searchName: null,
      dialog: false,
      loading: false,
    };
  },
  computed: {
    disabled() {
      return this.loading || !this.searchName;
    },
  },
  methods: {
    close() {
      this.searchName = null;
      this.loading = false;
      this.dialog = false;
    },
    async createSearch() {
      if (this.disabled) return;

      this.loading = true;
      const payload = {
        name: this.searchName,
        filters: this.search.filters,
        sort: this.search.sort || null,
        searcher: this.search.entity,
      };
      await this.$store.dispatch('searcher/SAVE_SEARCH', payload);
      this.close();
      this.$emit('created', payload);
    },
  },
};
</script>
